export default "__VITE_ASSET__c22ad8ca__"